<template>
  <div :id="slug" class="article-container">
    <h2>{{ title }}</h2>
    <article class="article">
      <header class="article__header">
        <div class="video-container-large">
          <iframe
            v-if="feed[0].webinars[0].vimeo_id"
            :src="getVideo()"
            frameborder="0"
            webkitAllowFullScreen
            mozallowfullscreen
            allowFullScreen
            width="800"
            height="500"
          />
          <!-- <div v-if="youtubeCode" v-html="youtubeCode"></div> -->
          <iframe
            v-if="feed[0].youtube_embed_code"
            width="800"
            height="500"
            :src="getYTVideo()"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
          <!-- <iframe v-if="youtubeCode" width="560" height="315" :src='getYTVideo()' title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> -->
        </div>
        <div class="video-info-container">
          <article class="article-card">
            <section class="article-card__body">
              <p class="product-display-title" v-if="feed[0].name">
                {{ title }}
              </p>
              <p class="product-display-subtitle" v-if="feed[0].subTitle">
                {{ feed[0].subTitle }}
              </p>
              <p
                v-if="feed[0].publish_date || feed[0].webinar_date"
                class="product-display-date"
              >
                {{ date }}
              </p>
              <!-- <p v-if="!feed[0].publish_date && feed[0].webinar_date" class="product-display-date">{{ feed[0].webinar_date }}</p> -->
              <div
                v-if="feed[0].short_description"
                v-html="feed[0].short_description"
                class="product-display-description"
              ></div>
              <!-- <p v-if="hasButton" class="button-green download-slides"><a :href="buttonUrl">Download Slides</a> -->
              <p v-if="slides" class="button-green download-slides">
                <a :href="'/storage/' + feed[0].webinars[0].pptAttachment">
                  Download Slides
                </a>
              </p>
            </section>
          </article>
        </div>
      </header>
      <section class="article__body">
        <ProductDisplayComponent :product="productInfo" />
      </section>
    </article>
  </div>
</template>

<script>
  import ProductDisplayComponent from '../../components/insider/ProductDisplayComponent.vue';

  import moment from 'moment';
  export default {
    name: 'ProductPageComponent',
    components: { ProductDisplayComponent },
    props: {
      // We have this `feed` on page load
      feed: {
        type: Array,
        required: false,
        default: () => [],
      },
      title: {
        type: String,
        // required: true,
      },
      slug: {
        type: String,
      },
      slides: {
        type: String,
      },
    },
    data: () => ({
      scrollPosition: 0,
      ismobiledevice: false,
      jsonReady: true,
      // hasVideo: true,
      productInfo: null,
      date: null,
    }),
    async created() {
      let url = window.location.pathname;

      if (url.includes('business-series-webinars')) {
        try {
          const { data } = await axios.get('/insider/business_series_webinars');
          this.productInfo = {
            slug: 'business-series-webinars',
            title: 'Watch More...',
            cards: data,
          };
        } catch (err) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }

        let activeDiv = document.getElementById(
          'insider-business-series-webinars'
        );
        this.$nextTick(() => {
          if (!activeDiv.classList.contains('active')) {
            activeDiv.classList.add('active');
          }
        });
      } else {
        this.$nextTick(() => activeDiv.classList.remove('active'));
      }
    },
    mounted() {
      this.date = this.format_date_month_year(
        this.what_date_to_use(
          this.feed[0].publish_date,
          this.feed[0].webinar_date
        )
      );
    },
    methods: {
      what_date_to_use(publishDate, webinarDate) {
        if (publishDate) {
          return publishDate;
        } else {
          return webinarDate;
        }
      },
      format_date_month_year(value) {
        if (value) {
          return moment(String(value)).format('MMMM YYYY');
        }
      },
      format_date_month_day_year(value) {
        if (value) {
          return moment(String(value)).format('MMMM DD, YYYY');
        }
      },
      format_published_on_date(value) {
        if (value) {
          return (
            'Published on ' + moment(String(value)).format('MMMM DD, YYYY')
          );
        }
      },
      getVideo() {
        return (
          'https://player.vimeo.com/video/' + this.feed[0].webinars[0].vimeo_id
        );
      },
      getYTVideo() {
        return 'https://www.youtube.com/embed/' + this.youtubeCode;
      },
      goToPage: function () {
        window.location.href = this.buttonUrl;
      },
      // goToUnlockPage: function (){
      //     // var currentUrl = window. location;
      //     window.location.href = 'http://local.itrondemand.com/store/product/2023-in-our-sights-manufacturing';
      //     // window.location.href = 'http://local.itrondemand.com/store/product/2023-in-our-sights-manufacturing';
      // },
    },
  };
</script>

<style lang="scss" scoped>
  // .product-embed-container {
  //     img {
  //         height: 8vw;
  //         width: 16vw;
  //         z-index: 99999;
  //         position: absolute;
  //         /* padding-left: 90px; */
  //         background: #000000;
  //         opacity: .8;
  //     }
  // }
  .article-container {
    padding-left: 50px;
    padding-top: 30px;
  }
  .article {
    display: flex;
    flex-direction: column;
    row-gap: 50px;

    &__header {
      .article-card {
        display: flex;
        flex-direction: column;
        min-height: 350px;
        // max-height: 350px;
        max-width: 300px;
        min-width: 300px;
        border: none;
        padding: 6px;

        &__header {
          position: relative;
          border: none;

          .video-container-large {
            background: none;
            bottom: 0%;
            width: 100%;
            position: relative;
            // padding-left: 5%;
            overflow: hidden;
            max-width: 100%;
          }
        }

        &__body {
          display: flex;
          flex-direction: column;
          row-gap: 10px;

          .product-display-title {
            font-size: 25px;
            color: #183961;
            font-weight: 900;
            text-align: right;
          }

          .product-display-subtitle {
            font-size: 18px;
            color: #3075a4;
            font-weight: 900;
            text-align: right;
          }
          .product-display-date {
            color: #a7a9ab;
            font-size: 15px;
            text-align: right;
            margin-bottom: 10px;
          }
          .product-display-description {
            text-align: right;
            font-size: 15px;
          }

          .button-green.download-slides {
            text-align: center;

            a {
              color: #fff;
            }
          }
        }
      }
    }
    &__body {
    }
  }
</style>
